var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClicColInterno',{key:_vm.componentKey,attrs:{"cp":_vm.cp}},[_c('b-breadcrumb',{class:_vm.card ? 'breadcrumb-card-container' : '',attrs:{"items":_vm.items},on:{"click":_vm.click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }